// src/services/directoryData.js
//
// Qué cheques y reclamos carga cada rol en su lista de reclamos. Lo usan
// ClaimsDirectory y el inicio del ajustador (useAdjusterHomeData), para que
// los dos lean exactamente lo mismo que firestore.rules le permite a cada uno:
// - CSR Assistant: el espejo de cheques de sus compañías.
// - Ajustador sin "ver todos": solo los suyos (y los compartidos con él).
// - P.A Admin / ajustador con "ver todos": toda su compañía.
// - Super Admin (sin compañía fija): todo.
import { getAllChecksForDirectory, getChecksForDirectoryByCompany, getChecksForDirectoryByCompanyAndAdjuster, getCheckSummariesByCompanies } from './claimService';
import { getAllClaimRecords, getClaimRecordsByCompany, getClaimRecordsByCompanies, getClaimRecordsByCompanyAndAdjuster } from './claimRecordService';
import { hasAccess } from '../utils/claimAccess';

export const loadDirectoryChecks = async ({ csrMode = false, userCompanies = [], lockedCompany = null, lockedAdjuster = null } = {}) => {
  const data = csrMode
    ? await getCheckSummariesByCompanies(userCompanies)
    : lockedAdjuster
      ? await getChecksForDirectoryByCompanyAndAdjuster(lockedCompany, lockedAdjuster)
      : lockedCompany
        ? await getChecksForDirectoryByCompany(lockedCompany)
        : await getAllChecksForDirectory();
  return data || [];
};

export const loadDirectoryRecords = async ({ csrMode = false, userCompanies = [], lockedCompany = null, lockedAdjuster = null } = {}) => {
  const records = csrMode
    ? await getClaimRecordsByCompanies(userCompanies)
    : lockedCompany && lockedAdjuster
      ? await getClaimRecordsByCompanyAndAdjuster(lockedCompany, lockedAdjuster)
      : lockedCompany
        ? await getClaimRecordsByCompany(lockedCompany)
        : await getAllClaimRecords();
  return lockedAdjuster ? (records || []).filter(cr => hasAccess(cr, lockedAdjuster)) : (records || []);
};
